

const CustomModal = ({ show, onClose, children,title ,height}) => {
  if (!show) return null;
  const handleModalContentClick = (e) => {
    e.stopPropagation();
  }
  return (
    <div className="modal-overlay" onClick={() => onClose()} 
>
      <div  onClick={handleModalContentClick} className="modal" style={{height:height?"fit-content":"92vh"}}>
        <div className="flex justify-between items-center h-[10%] border-b border-green" >
            <h4 className="text-20 font-semibold text-green" >{title}</h4>
            <button className="modal-close" onClick={onClose}>×</button>
            </div>
        <div className="custom-modal-content">{children}</div>
      </div>
    </div>
  );
};

export default CustomModal;
